export default "__VITE_ASSET__BVQ2oNEB__"